import ShowPolls from './polls.js';
import CreateVote from './CreateVote.js';
const VoteCard = () => {
	return (
		<>
			<ShowPolls />
			<CreateVote />
		</>
	);
};
export default VoteCard;
